import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import HistoryClinicDialog from "../../../../historyClinic/HistoryClinicDetail/historyClinic";
import CloseIcon from "@material-ui/icons/Close";
import { calculateAge } from "../../../../../utils/DateUtil";
import { GetPetImages } from "../../../../../services/petService";
import { useStateAuthValue } from "../../../../../context/Auth/AuthState";
import { PicturePet } from "../../../../../components/picture-pet";

const Patient = ({ patient }) => {
  const [open, setOpen] = useState(false);
  const [{ userToken }] = useStateAuthValue();
  const [imagePuppy, setImagePuppy] = useState("");
  const [imageAdult, setImageAdult] = useState("");
  const openHistoryClinic = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const styleCloseDialog = {
    position: "absolute",
    top: 0,
    right: 0,
  };
  const getImages = async () => {
    try {
      const result = await GetPetImages(patient.patient_dto.id, userToken);
      if (result.status === 200) {
        const images = result.data || [];
        const imageAdult = images.find((e) => e.type === "ADULT");
        const imagePuppy = images.find((e) => e.type === "PUPPY");

        if (imageAdult) {
          const image = `data:image/png;base64,${imageAdult.photo}`;
          setImageAdult(image);
        }
        if (imagePuppy) {
          const image = `data:image/png;base64,${imagePuppy.photo}`;
          setImagePuppy(image);
        }
      }
      return [];
    } catch (error) {
      return [];
    }
  };

  const age = calculateAge(patient.birth_date) ?? 0;

  useEffect(() => {
    if (patient) {
      getImages();
    }
  }, [patient]);

  return (
    <div className="accordion-patient">
      <div className="detail-wrapper">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          {imageAdult.length > 0 ? (
            <PicturePet url={imageAdult} />
          ) : (
            <PicturePet url={imagePuppy} />
          )}
        </div>
        <div className="detail">
          <span className="data">Especie: {`${patient?.species}`}</span>
        </div>
        <div className="detail">
          <span className="data">Raza: {patient?.race}</span>
        </div>
        <div className="detail">
          <span className="data">Edad: {age}</span>
        </div>
      </div>

      <Tooltip
        title={
          !patient?.familymember
            ? "No se encontró el paciente"
            : "Historia Clínica del paciente"
        }
        arrow
      >
        <Button
          disabled={!patient?.familymember}
          className="button-hc"
          onClick={openHistoryClinic}
        >
          Historia Clínica
        </Button>
      </Tooltip>

      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <div style={styleCloseDialog} className="close">
          <Tooltip title="Cerrar">
            <IconButton onClick={() => handleClose(false)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
        <DialogContent>
          <HistoryClinicDialog
            email={patient?.familymember || ""}
            showHeader={true}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Patient;
